import { SVGProps } from "react";

export default function CelleraLogo({
  width = "214",
  height = "65",
  className = "",
  fill = "#000080",
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 214 65"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M175.659 21.56C177.101 21.6934 179.087 22.3734 180.297 23.1773C184.81 26.1759 184.059 34.1021 178.783 35.8423L183.516 42.9386H179.244L174.895 36.6781H169.327V42.9386H165.361V21.56C168.679 21.7855 172.388 21.2566 175.659 21.56ZM169.327 33.3183H175.506C175.773 33.3183 176.809 32.9369 177.114 32.7894C179.991 31.4046 179.998 26.8547 177.061 25.5007C176.684 25.3271 175.398 24.9186 175.049 24.9186H169.327V33.3171V33.3183Z"
        fill={fill}
      />
      <path
        d="M160.326 21.5601V24.9199H148.731V30.4165H159.105V33.5474L158.876 33.7764H148.731V39.58H160.783V42.9386H144.764V21.5601H160.326Z"
        fill={fill}
      />
      <path
        d="M103.114 21.5601V24.9199H91.5192V30.4165H101.894V33.5474L101.665 33.7764H91.5192V39.58H103.572V42.9386H87.5527V21.5601H103.114Z"
        fill={fill}
      />
      <path
        d="M207.774 42.9387H203.731L201.418 38.0772L190.669 38.1433L188.627 42.9398H184.583L194.118 21.7124C194.342 21.4408 197.694 21.4904 198.239 21.7124L207.774 42.9398V42.9387ZM200.145 34.846L196.028 25.6837L192.212 34.846H200.145Z"
        fill={fill}
      />
      <path
        d="M74.0963 21.3C77.5958 20.9896 81.357 22.019 83.7277 24.7107L81.219 27.1721C77.5675 23.2149 70.3386 24.1664 68.4126 29.3538C66.2624 35.1432 70.5545 40.3966 76.6286 39.7155C78.5181 39.503 79.9322 38.431 81.3535 37.2989L83.7277 39.6765C78.2763 45.9098 66.7106 43.7423 64.3199 35.5753C62.2606 28.5368 66.864 21.9423 74.0963 21.3Z"
        fill={fill}
      />
      <path
        d="M130.423 21.5601V39.58H141.561V42.9386H126.457V21.5601H130.423Z"
        fill={fill}
      />
      <path
        d="M112.116 21.5601V39.58H123.252V42.9386H108.149V21.5601H112.116Z"
        fill={fill}
      />
      <path
        d="M54.0139 44.6667C55.8586 44.6927 55.8055 47.4953 54.0139 47.4929C52.2223 47.4906 52.102 44.6407 54.0139 44.6667Z"
        fill={fill}
      />
      <path
        d="M51.1101 43.0223C52.9382 42.7968 53.193 45.5641 51.4769 45.7931C49.6016 46.0434 49.3102 43.2443 51.1101 43.0223Z"
        fill={fill}
      />
      <path
        d="M45.6587 39.3851C47.5517 39.1407 47.784 41.9611 46.0255 42.1559C44.1891 42.3601 43.9414 39.6071 45.6587 39.3851Z"
        fill={fill}
      />
      <path
        d="M48.1874 41.2667C49.7278 40.9515 50.5935 42.8286 49.4058 43.7199C48.2181 44.6112 46.7037 43.3185 47.3359 41.9727C47.4668 41.6929 47.8867 41.3281 48.1874 41.2667Z"
        fill={fill}
      />
      <path
        d="M51.3684 47.8931C53.3286 47.5661 53.561 50.5647 51.6715 50.5989C50.0238 50.6284 49.8221 48.1516 51.3684 47.8931Z"
        fill={fill}
      />
      <path
        d="M49.9342 46.4718C50.5711 47.1081 50.3588 48.3559 49.5025 48.6888C48.3655 49.1316 47.2934 48.0478 47.738 46.9227C48.0848 46.0456 49.2831 45.8201 49.9342 46.4718Z"
        fill={fill}
      />
      <path
        d="M45.9819 44.321C47.8548 43.9975 48.1249 46.6254 46.5999 46.8875C44.6562 47.2228 44.4427 44.5866 45.9819 44.321Z"
        fill={fill}
      />
      <path
        d="M42.7997 42.5642C42.9495 42.5194 43.965 42.5265 44.136 42.5642C44.7045 42.6917 44.8401 43.6315 44.7375 44.1131C44.4368 45.531 41.8962 45.2949 42.1864 43.4426C42.2276 43.1829 42.5485 42.6386 42.8009 42.5631L42.7997 42.5642Z"
        fill={fill}
      />
      <path
        d="M48.6427 50.6864C50.4461 50.3783 50.6584 52.9341 49.1959 53.188C47.3819 53.5032 47.0917 50.9508 48.6427 50.6864Z"
        fill={fill}
      />
      <path
        d="M45.8521 48.8021C47.9633 48.4148 47.9598 51.3721 46.167 51.3143C44.6526 51.2647 44.5618 49.0382 45.8521 48.8021Z"
        fill={fill}
      />
      <path
        d="M41.6285 45.107C42.2265 45.6666 42.0578 46.8342 41.277 47.1458C40.2757 47.5449 39.2873 46.7456 39.5538 45.6808C39.7791 44.78 40.9692 44.4896 41.6285 45.107Z"
        fill={fill}
      />
      <path
        d="M43.452 46.8557C45.1586 46.7895 45.1669 49.5627 43.2456 49.3006C41.9199 49.12 41.9458 46.9135 43.452 46.8557Z"
        fill={fill}
      />
      <path
        d="M43.1276 50.7501C44.6762 50.5258 45.0442 52.9364 43.4944 53.1336C41.8137 53.3473 41.6486 50.9649 43.1276 50.7501Z"
        fill={fill}
      />
      <path
        d="M45.8556 52.8278C47.3559 52.679 47.547 54.9634 46.1552 55.1464C44.4745 55.3683 44.2764 52.9836 45.8556 52.8278Z"
        fill={fill}
      />
      <path
        d="M40.4692 48.6064C42.0189 48.4812 42.1546 50.8459 40.58 50.8718C39.0821 50.8954 39.0691 48.7197 40.4692 48.6064Z"
        fill={fill}
      />
      <path
        d="M36.9355 48.1799C36.5416 47.7868 36.531 46.9663 36.9426 46.5755C37.8626 45.7031 39.2838 46.7644 38.7153 47.8954C38.4004 48.5211 37.425 48.6698 36.9343 48.1799H36.9355Z"
        fill={fill}
      />
      <path
        d="M42.867 54.4549C44.5441 54.1728 44.6857 56.7239 42.9778 56.5858C41.717 56.4843 41.7418 54.6438 42.867 54.4549Z"
        fill={fill}
      />
      <path
        d="M40.2061 52.1161C41.8892 51.8328 42.0661 54.4607 40.2545 54.2447C39.1269 54.1101 39.075 52.3062 40.2061 52.1161Z"
        fill={fill}
      />
      <path
        d="M37.6774 49.6476C39.2083 49.4693 39.3628 51.8941 37.6585 51.71C36.4496 51.5801 36.4956 49.7845 37.6774 49.6476Z"
        fill={fill}
      />
      <path
        d="M40.1436 55.4934C41.5495 55.3411 41.6981 57.3918 40.4443 57.5511C38.9653 57.7388 38.8474 55.6339 40.1436 55.4934Z"
        fill={fill}
      />
      <path
        d="M37.5453 52.9602C39.0054 52.697 39.2401 54.8574 37.8448 54.9542C36.5592 55.0427 36.3894 53.168 37.5453 52.9602Z"
        fill={fill}
      />
      <path
        d="M37.2893 56.2066C38.6929 56.0685 38.8568 58.4071 37.1443 58.1368C36.1111 57.9739 36.1653 56.3164 37.2893 56.2066Z"
        fill={fill}
      />
      <path
        d="M34.3643 47.1129C35.8988 46.8012 35.9955 49.3016 34.3537 49.0419C33.3571 48.8849 33.3559 47.3183 34.3643 47.1129Z"
        fill={fill}
      />
      <path
        d="M34.8196 50.2969C36.4165 50.0266 36.3623 52.4515 34.8844 52.2153C33.7876 52.0394 33.8076 50.4693 34.8196 50.2969Z"
        fill={fill}
      />
      <path
        d="M35.0142 53.4148C36.3541 53.2011 36.5699 55.2186 35.2501 55.345C34.0294 55.4618 33.7475 53.6166 35.0142 53.4148Z"
        fill={fill}
      />
      <path
        d="M32.2885 53.4794C33.6142 53.2409 33.8925 55.1203 32.7131 55.3328C31.3756 55.5737 31.1114 53.6919 32.2885 53.4794Z"
        fill={fill}
      />
      <path
        d="M33.8206 56.864C34.7122 55.975 36.117 57.3681 35.164 58.2417C34.2251 59.1035 33.0091 57.6727 33.8206 56.864Z"
        fill={fill}
      />
      <path
        d="M32.9324 50.6272C34.0529 51.7558 31.8462 53.0036 31.3826 51.6908C31.0017 50.6142 32.2967 49.9861 32.9324 50.6272Z"
        fill={fill}
      />
      <path
        d="M31.51 56.5973C32.9183 56.3742 33.1105 58.5995 31.4923 58.4024C30.557 58.2878 30.5146 56.7543 31.51 56.5973Z"
        fill={fill}
      />
      <path
        d="M31.2506 47.2441C32.6081 46.9927 32.8074 48.8461 31.674 49.0315C30.3754 49.244 30.2138 47.4365 31.2506 47.2441Z"
        fill={fill}
      />
      <path
        d="M29.7515 53.227C30.6526 53.1892 31.0972 54.3615 30.3259 54.8927C29.9685 55.1395 29.3469 55.0722 29.0603 54.731C28.5756 54.1549 29.0119 53.2577 29.7515 53.227Z"
        fill={fill}
      />
      <path
        d="M14.8268 49.9992C14.1663 50.6544 13.0269 50.0205 13.2569 49.1103C13.4869 48.2001 14.9412 48.2945 15.045 49.1433C15.0803 49.4373 15.045 49.7844 14.8268 50.0004V49.9992Z"
        fill={fill}
      />
      <path
        d="M16.9026 50.6284C17.3531 51.0817 17.1962 52.0179 16.5534 52.1501C15.7703 52.3118 15.236 51.8278 15.3705 51.0321C15.4825 50.3663 16.4544 50.1774 16.9026 50.6284Z"
        fill={fill}
      />
      <path
        d="M28.7207 56.2705C29.6406 56.1407 30.1997 57.4039 29.3411 57.9363C28.0342 58.7461 27.2983 56.4712 28.7207 56.2705Z"
        fill={fill}
      />
      <path
        d="M18.2059 52.1146C19.699 51.8041 19.8323 53.9586 18.3828 53.8571C17.3295 53.7839 17.326 52.2976 18.2059 52.1146Z"
        fill={fill}
      />
      <path
        d="M29.1724 50.1011C30.6856 49.7882 30.7753 51.9687 29.3528 51.84C28.3008 51.7444 28.3232 50.2758 29.1724 50.1011Z"
        fill={fill}
      />
      <path
        d="M12.0397 46.3337C13.5011 46.0326 13.6686 48.1777 12.2167 48.0762C11.154 48.0018 11.1976 46.5072 12.0397 46.3337Z"
        fill={fill}
      />
      <path
        d="M27.034 52.6967C28.1569 52.5396 28.4293 54.3494 27.2699 54.497C26.0397 54.6552 25.8157 52.8655 27.034 52.6967Z"
        fill={fill}
      />
      <path
        d="M25.864 55.6886C27.1461 55.4548 27.3902 57.3342 26.1565 57.4794C25.049 57.6093 24.7884 55.8845 25.864 55.6886Z"
        fill={fill}
      />
      <path
        d="M20.7382 53.5444C22.0485 53.3367 22.1547 55.2669 20.9658 55.3318C19.8265 55.3944 19.6932 53.7097 20.7382 53.5444Z"
        fill={fill}
      />
      <path
        d="M23.2669 54.778C24.6397 54.529 24.7412 56.6646 23.3164 56.5182C22.3386 56.4178 22.3233 54.9492 23.2669 54.778Z"
        fill={fill}
      />
      <path
        d="M10.727 43.9512C11.7224 43.9512 11.9465 45.3206 11.0962 45.65C9.73743 46.1753 9.32699 43.9524 10.727 43.9512Z"
        fill={fill}
      />
      <path
        d="M9.24915 41.4626C10.681 41.1639 10.7317 43.3527 9.37182 43.1968C8.38698 43.0847 8.37636 41.6444 9.24915 41.4626Z"
        fill={fill}
      />
      <path
        d="M8.4082 38.7959C9.53339 38.6661 9.77164 40.5632 8.51434 40.5963C7.41864 40.6258 7.2948 38.9246 8.4082 38.7959Z"
        fill={fill}
      />
      <path
        d="M24.2411 51.855C25.6305 51.567 25.6989 53.457 24.5985 53.5822C23.4981 53.7073 23.248 52.0616 24.2411 51.855Z"
        fill={fill}
      />
      <path
        d="M19.3735 49.062C20.3123 48.8684 20.9162 50.0619 20.1 50.6333C18.9123 51.4656 18.0997 49.3241 19.3735 49.062Z"
        fill={fill}
      />
      <path
        d="M7.56256 36.1363C9.09348 35.8211 9.00148 37.9921 7.76071 37.8611C6.75464 37.7548 6.76289 36.3016 7.56256 36.1363Z"
        fill={fill}
      />
      <path
        d="M26.4455 49.3852C27.7877 49.0795 27.9493 50.9837 26.804 51.1136C25.6989 51.2387 25.5102 49.5989 26.4455 49.3852Z"
        fill={fill}
      />
      <path
        d="M17.1668 47.3725C18.6836 47.0632 18.6128 49.4986 17.0512 49.017C16.3718 48.808 16.3612 47.5366 17.1668 47.3725Z"
        fill={fill}
      />
      <path
        d="M21.2949 52.1434C21.2371 52.0856 21.1097 51.8719 21.092 51.794C20.7735 50.3749 22.9272 50.2522 22.7668 51.6794C22.689 52.3712 21.7525 52.6003 21.2949 52.1434Z"
        fill={fill}
      />
      <path
        d="M7.37031 33.3418C8.56863 33.167 8.71134 35.0099 7.53897 35.0583C6.43383 35.1043 6.33829 33.4929 7.37031 33.3418Z"
        fill={fill}
      />
      <path
        d="M7.69465 27.7544C8.57805 27.6328 9.0687 28.8748 8.25135 29.3553C7.04123 30.0683 6.36541 27.9362 7.69465 27.7544Z"
        fill={fill}
      />
      <path
        d="M6.88786 32.0065C6.14481 31.2627 7.25231 29.9806 8.10269 30.7586C8.94246 31.5272 7.6946 32.814 6.88786 32.0065Z"
        fill={fill}
      />
      <path
        d="M28.3963 46.7858C29.433 46.6441 29.7609 48.2367 28.7537 48.4468C27.4539 48.7171 27.297 46.9357 28.3963 46.7858Z"
        fill={fill}
      />
      <path
        d="M23.7846 48.2816C25.0325 47.9971 25.2896 49.7868 24.1432 49.9438C23.0758 50.0902 22.8753 48.4893 23.7846 48.2816Z"
        fill={fill}
      />
      <path
        d="M15.2195 45.3599C16.6997 45.0518 16.6336 47.4105 15.1039 46.9395C14.4705 46.7447 14.4434 45.5205 15.2195 45.3599Z"
        fill={fill}
      />
      <path
        d="M8.21242 25.092C9.36238 24.8594 9.59119 26.6161 8.51672 26.7636C7.44224 26.9112 7.22168 25.2927 8.21242 25.092Z"
        fill={fill}
      />
      <path
        d="M13.6626 43.1509C14.8621 42.9325 14.9624 44.5629 14.0872 44.7447C12.8665 44.9973 12.6967 43.328 13.6626 43.1509Z"
        fill={fill}
      />
      <path
        d="M11.3934 38.083C12.6047 37.9071 12.7179 39.8539 11.3745 39.6945C10.5288 39.5941 10.4616 38.2188 11.3934 38.083Z"
        fill={fill}
      />
      <path
        d="M12.2992 40.6824C13.652 40.4061 13.6615 42.5028 12.3653 42.2761C11.5066 42.1262 11.5031 40.8453 12.2992 40.6824Z"
        fill={fill}
      />
      <path
        d="M9.05452 22.4949C10.2658 22.2458 10.3767 23.921 9.41307 24.0887C8.31972 24.2799 8.10506 22.6897 9.05452 22.4949Z"
        fill={fill}
      />
      <path
        d="M10.2246 19.96C11.5031 19.7522 11.4984 21.7544 10.2128 21.5655C9.35767 21.4404 9.39188 20.0946 10.2246 19.96Z"
        fill={fill}
      />
      <path
        d="M19.1801 44.9039C20.4857 44.6796 20.4716 46.729 19.1942 46.4858C18.3344 46.3217 18.371 45.0432 19.1801 44.9039Z"
        fill={fill}
      />
      <path
        d="M10.6786 35.3558C11.825 35.1563 12.0161 36.8339 10.9699 36.9519C9.9155 37.0712 9.72797 35.5211 10.6786 35.3558Z"
        fill={fill}
      />
      <path
        d="M10.418 29.7693C11.3344 29.5804 11.805 30.8329 10.9994 31.2615C9.85655 31.8695 9.29395 30.0006 10.418 29.7693Z"
        fill={fill}
      />
      <path
        d="M11.6541 17.5553C12.8878 17.3853 12.8158 19.3721 11.6022 19.1396C10.7129 18.9696 10.7789 17.6757 11.6541 17.5553Z"
        fill={fill}
      />
      <path
        d="M10.4852 32.5603C11.3828 32.4599 11.7378 33.7385 10.9051 34.0903C9.74922 34.5778 9.31518 32.6925 10.4852 32.5603Z"
        fill={fill}
      />
      <path
        d="M26.3134 47.1413C25.5114 47.9086 24.3473 46.6383 25.2295 45.9583C26.0409 45.3338 26.9857 46.4979 26.3134 47.1413Z"
        fill={fill}
      />
      <path
        d="M10.8072 26.9764C12.0999 26.7119 12.1447 28.7047 10.8615 28.5158C10.0477 28.3966 10.0288 27.1346 10.8072 26.9764Z"
        fill={fill}
      />
      <path
        d="M22.1594 48.1151C21.3644 48.9108 20.277 47.6511 21.0436 46.9652C21.8103 46.2793 22.8623 47.4103 22.1594 48.1151Z"
        fill={fill}
      />
      <path
        d="M12.4254 24.4498C13.1448 25.138 12.101 26.2808 11.3485 25.6244C10.563 24.9385 11.6634 23.7214 12.4254 24.4498Z"
        fill={fill}
      />
      <path
        d="M13.2746 15.4126C14.1285 15.2733 14.5614 16.416 13.8065 16.8576C12.7132 17.4962 12.1164 15.6015 13.2746 15.4126Z"
        fill={fill}
      />
      <path
        d="M13.7263 35.1598C15.1865 34.8281 14.9742 36.9212 13.8089 36.6095C13.0977 36.4194 13.0918 35.3038 13.7263 35.1598Z"
        fill={fill}
      />
      <path
        d="M16.5157 40.6873C17.1314 41.3838 16.0946 42.49 15.3893 41.7498C14.684 41.0096 15.8882 39.979 16.5157 40.6873Z"
        fill={fill}
      />
      <path
        d="M12.7545 21.6497C13.7912 21.4372 14.053 22.9211 13.1142 23.1147C12.081 23.3272 11.8534 21.835 12.7545 21.6497Z"
        fill={fill}
      />
      <path
        d="M15.0261 13.465C16.0675 13.2513 16.2433 14.7234 15.4495 14.9277C14.3455 15.2122 14.1297 13.648 15.0261 13.465Z"
        fill={fill}
      />
      <path
        d="M17.1679 42.8921C18.4677 42.5592 18.5385 44.3596 17.4758 44.3572C16.5664 44.3548 16.5086 43.061 17.1679 42.8921Z"
        fill={fill}
      />
      <path
        d="M14.5732 37.8882C15.7161 37.7016 15.7491 39.4902 14.6286 39.3639C13.7948 39.2694 13.7358 38.0251 14.5732 37.8882Z"
        fill={fill}
      />
      <path
        d="M23.1407 44.3174C24.1125 44.2076 24.2092 45.6644 23.3789 45.7955C22.3209 45.9631 22.1865 44.4237 23.1407 44.3174Z"
        fill={fill}
      />
      <path
        d="M17.0382 11.7107C18.0584 11.5124 18.2082 13.079 17.2753 13.1899C16.3423 13.3009 16.1513 11.8831 17.0382 11.7107Z"
        fill={fill}
      />
      <path
        d="M14.2488 19.2435C15.2171 19.1349 15.3516 20.6141 14.4198 20.7239C13.4409 20.8396 13.3029 19.3497 14.2488 19.2435Z"
        fill={fill}
      />
      <path
        d="M13.6001 32.3655C14.5284 32.2392 14.7548 33.7349 13.7546 33.8105C12.7545 33.886 12.6872 32.4906 13.6001 32.3655Z"
        fill={fill}
      />
      <path
        d="M19.8241 11.4805C19.1483 12.1298 18.1611 11.137 18.7791 10.4664C19.4042 9.78763 20.5436 10.7876 19.8241 11.4805Z"
        fill={fill}
      />
      <path
        d="M13.5966 29.5736C14.6687 29.3269 14.8574 30.8675 13.8902 30.9773C12.9974 31.0776 12.8134 29.7542 13.5966 29.5736Z"
        fill={fill}
      />
      <path
        d="M14.8256 27.9135C14.6086 28.1283 14.0696 28.1378 13.8408 27.9371C13.3949 27.5475 13.6556 26.7518 14.2312 26.6987C14.9341 26.6326 15.3092 27.4353 14.8256 27.9135Z"
        fill={fill}
      />
      <path
        d="M16.5782 17.2401C17.1278 17.7961 16.3789 18.8692 15.6241 18.2919C14.8267 17.6816 15.8977 16.5518 16.5782 17.2401Z"
        fill={fill}
      />
      <path
        d="M20.9327 42.3681C21.6569 42.23 22.0874 43.3586 21.3562 43.7045C20.3182 44.1968 19.9385 42.5582 20.9327 42.3681Z"
        fill={fill}
      />
      <path
        d="M21.4506 8.98201C22.1417 8.91708 22.5132 9.92055 21.8374 10.2806C20.8007 10.8331 20.3607 9.08472 21.4506 8.98201Z"
        fill={fill}
      />
      <path
        d="M17.8839 15.0869C18.7826 14.9559 18.9324 16.251 18.1775 16.4245C17.1219 16.6677 17.0323 15.2109 17.8839 15.0869Z"
        fill={fill}
      />
      <path
        d="M18.9831 40.0968C20.2534 39.8064 20.1201 41.6316 19.0822 41.4049C18.3698 41.2491 18.3757 40.2361 18.9831 40.0968Z"
        fill={fill}
      />
      <path
        d="M17.753 37.4987C18.7083 37.3417 18.8263 38.73 17.9912 38.8457C17.0701 38.9732 16.9344 37.6333 17.753 37.4987Z"
        fill={fill}
      />
      <path
        d="M15.157 24.052C16.248 23.8431 16.222 25.595 15.157 25.3884C14.4411 25.2491 14.4517 24.1866 15.157 24.052Z"
        fill={fill}
      />
      <path
        d="M23.7221 7.94333C24.6173 7.86305 24.7518 9.23485 23.8365 9.29742C22.8647 9.36353 22.8941 8.01771 23.7221 7.94333Z"
        fill={fill}
      />
      <path
        d="M16.3872 21.5185C17.5654 21.2494 17.5501 23.1016 16.3247 22.7876C15.7314 22.6353 15.8187 21.6484 16.3872 21.5185Z"
        fill={fill}
      />
      <path
        d="M19.9573 13.4648C20.8997 13.2712 21.0082 14.5769 20.3183 14.7351C19.3346 14.9606 19.127 13.6348 19.9573 13.4648Z"
        fill={fill}
      />
      <path
        d="M16.9085 34.7055C18.0254 34.4942 17.9782 36.3276 16.7917 35.9616C16.222 35.7857 16.2952 34.8212 16.9085 34.7055Z"
        fill={fill}
      />
      <path
        d="M16.5169 31.8471C17.3296 31.6606 17.7011 32.5921 17.0878 33.0029C16.2338 33.5755 15.6312 32.0502 16.5169 31.8471Z"
        fill={fill}
      />
      <path
        d="M16.8436 28.924C17.7695 28.747 17.9193 30.1105 17.0807 30.2073C16.2256 30.3065 16.0794 29.0704 16.8436 28.924Z"
        fill={fill}
      />
      <path
        d="M22.229 12.0363C23.0558 11.8687 23.2905 12.937 22.6536 13.2404C21.7419 13.6737 21.3444 12.2157 22.229 12.0363Z"
        fill={fill}
      />
      <path
        d="M18.0738 19.2449C19.0103 18.9675 19.2792 20.1516 18.6612 20.416C17.6751 20.8375 17.405 19.4421 18.0738 19.2449Z"
        fill={fill}
      />
      <path
        d="M17.7471 26.0707C18.627 26.0271 18.6482 27.5453 17.6221 27.3363C16.8884 27.1864 17.017 26.1073 17.7471 26.0707Z"
        fill={fill}
      />
      <path
        d="M20.2675 17.186C21.1922 17.1825 21.1014 18.4575 20.2675 18.4575C19.4172 18.4575 19.4761 17.1896 20.2675 17.186Z"
        fill={fill}
      />
      <path
        d="M25.8617 7.229C27.0482 6.95866 26.981 8.72004 25.864 8.43317C25.318 8.29268 25.3215 7.35178 25.8617 7.229Z"
        fill={fill}
      />
      <path
        d="M18.7885 23.4674C19.7757 23.242 19.922 24.524 19.1483 24.674C18.3215 24.8333 18.0962 23.6256 18.7885 23.4674Z"
        fill={fill}
      />
      <path
        d="M24.214 11.1318C24.7554 10.6289 25.6706 11.3927 25.1328 12.0184C24.5879 12.6524 23.5606 11.7387 24.214 11.1318Z"
        fill={fill}
      />
      <path
        d="M28.263 6.77353C29.1158 6.5811 29.3021 7.70499 28.6746 7.89978C27.783 8.17603 27.5247 6.93999 28.263 6.77353Z"
        fill={fill}
      />
      <path
        d="M20.6721 21.0641C21.4859 20.9071 21.6581 22.0498 20.967 22.2057C20.0824 22.4052 19.9196 21.2093 20.6721 21.0641Z"
        fill={fill}
      />
      <path
        d="M22.1394 16.5449C21.5626 15.9664 22.5451 15.1141 23.0546 15.7256C23.524 16.2887 22.6913 17.0986 22.1394 16.5449Z"
        fill={fill}
      />
      <path
        d="M27.4173 10.4179C28.033 11.0932 26.7663 11.8806 26.449 11.0956C26.153 10.3625 27.034 9.99884 27.4173 10.4179Z"
        fill={fill}
      />
      <path
        d="M29.0415 9.76128C29.8978 9.50746 30.1124 10.6125 29.4531 10.8226C28.6487 11.08 28.4671 9.93128 29.0415 9.76128Z"
        fill={fill}
      />
      <path
        d="M22.591 19.9909C22.0733 19.5163 22.8128 18.658 23.3836 19.1657C23.912 19.6355 23.13 20.4843 22.591 19.9909Z"
        fill={fill}
      />
      <path
        d="M31.0524 7.4534C30.5452 7.91735 29.801 7.22673 30.2575 6.69076C30.754 6.10757 31.595 6.95638 31.0524 7.4534Z"
        fill={fill}
      />
      <path
        d="M25.3462 17.4243C26.1683 17.2885 26.1589 18.6981 25.279 18.5045C24.7046 18.3782 24.7624 17.5199 25.3462 17.4243Z"
        fill={fill}
      />
      <path
        d="M25.4076 14.4434C25.9265 15.0538 24.7954 15.7833 24.5029 15.0573C24.2328 14.3868 25.0585 14.0338 25.4076 14.4434Z"
        fill={fill}
      />
      <path
        d="M27.2239 13.3986C28.2583 13.0904 28.1592 14.6877 27.2392 14.3949C26.8064 14.2568 26.8064 13.5225 27.2239 13.3986Z"
        fill={fill}
      />
      <path
        d="M31.9641 9.69886C32.3922 10.1652 31.7176 10.844 31.2211 10.4426C30.6997 10.0212 31.4876 9.17942 31.9641 9.69886Z"
        fill={fill}
      />
      <path
        d="M32.4536 6.58358C32.9785 6.05941 33.7133 7.06052 33.0363 7.39462C32.4796 7.66968 32.0774 6.96017 32.4536 6.58358Z"
        fill={fill}
      />
      <path
        d="M28.0696 16.3843C28.7218 16.2485 28.8976 17.2047 28.2996 17.3346C27.5601 17.4963 27.4928 16.5047 28.0696 16.3843Z"
        fill={fill}
      />
      <path
        d="M29.8234 12.8802C30.5004 12.8177 30.5405 13.8306 29.873 13.8306C29.2054 13.8306 29.2726 12.9298 29.8234 12.8802Z"
        fill={fill}
      />
      <path
        d="M33.5198 9.63165C34.3997 9.36721 34.3112 10.837 33.4904 10.4781C33.1011 10.3081 33.1743 9.73554 33.5198 9.63165Z"
        fill={fill}
      />
      <path
        d="M30.57 16.0008C31.0217 15.5226 31.7813 16.3431 31.1739 16.7032C30.6302 17.0255 30.2669 16.3219 30.57 16.0008Z"
        fill={fill}
      />
      <path
        d="M34.5295 6.71067C34.9057 6.31282 35.6051 6.84997 35.2277 7.31275C34.8196 7.81448 34.1343 7.12858 34.5295 6.71067Z"
        fill={fill}
      />
      <path
        d="M32.2224 12.6822C32.9313 12.4744 32.9855 13.7471 32.1564 13.5015C31.7731 13.3882 31.8804 12.7826 32.2224 12.6822Z"
        fill={fill}
      />
      <path
        d="M33.6449 15.8695C34.1756 15.8117 34.2299 16.6617 33.6968 16.6971C33.1636 16.7325 33.1519 15.9238 33.6449 15.8695Z"
        fill={fill}
      />
      <path
        d="M36.7657 6.96814C37.3448 6.79578 37.4922 7.59265 37.0617 7.72133C36.4826 7.89369 36.3352 7.09682 36.7657 6.96814Z"
        fill={fill}
      />
      <path
        d="M36.1795 10.0269C36.6288 10.5735 35.427 11.0386 35.48 10.2346C35.5036 9.87929 35.9672 9.76714 36.1795 10.0269Z"
        fill={fill}
      />
      <path
        d="M35.0142 13.5627C34.5943 13.9617 34.0647 13.1294 34.5778 12.898C35.026 12.6961 35.3208 13.2711 35.0142 13.5627Z"
        fill={fill}
      />
      <path
        d="M38.6457 7.4217C39.3628 7.20094 39.2071 8.36024 38.6162 8.0769C38.3261 7.9376 38.3815 7.50434 38.6457 7.4217Z"
        fill={fill}
      />
      <path
        d="M37.8059 10.3436C38.3154 10.2515 38.3709 10.9669 37.9687 11.0366C37.458 11.1251 37.3801 10.4204 37.8059 10.3436Z"
        fill={fill}
      />
      <path
        d="M36.5734 16.4538C36.7892 16.6722 36.6135 17.2365 36.2019 17.0559C35.69 16.8304 36.2479 16.1244 36.5734 16.4538Z"
        fill={fill}
      />
      <path
        d="M36.9626 13.395C37.366 13.3207 37.5288 13.9204 37.1926 14.0219C36.6477 14.186 36.5357 13.4741 36.9626 13.395Z"
        fill={fill}
      />
      <path
        d="M40.5316 8.00498C40.9598 7.9247 41.0671 8.56692 40.6307 8.63303C40.2226 8.69442 40.1271 8.08053 40.5316 8.00498Z"
        fill={fill}
      />
      <path
        d="M39.5256 11.5499C39.3616 11.3846 39.443 10.975 39.7355 10.9891C40.3547 11.0186 39.9089 11.9383 39.5256 11.5499Z"
        fill={fill}
      />
      <path
        d="M38.9665 14.1094C39.4808 13.937 39.5751 14.6524 39.0868 14.6253C38.7483 14.6064 38.8085 14.1625 38.9665 14.1094Z"
        fill={fill}
      />
      <path
        d="M38.7118 17.3596C39.1953 17.2144 39.2413 17.9381 38.7672 17.8685C38.4794 17.8271 38.4535 17.4364 38.7118 17.3596Z"
        fill={fill}
      />
      <path
        d="M42.0566 8.78979C42.4152 8.43444 42.8115 9.16048 42.3279 9.23013C42.0354 9.27145 41.8608 8.9834 42.0566 8.78979Z"
        fill={fill}
      />
      <path
        d="M41.8361 11.8356C42.0519 12.1815 41.5283 12.492 41.3573 12.1508C41.1685 11.7754 41.7311 11.6691 41.8361 11.8356Z"
        fill={fill}
      />
      <path
        d="M40.9774 15.0823C41.3443 14.9607 41.4315 15.3833 41.2652 15.5014C40.9256 15.741 40.7026 15.1744 40.9774 15.0823Z"
        fill={fill}
      />
      <path
        d="M44.0428 9.56176C44.1962 9.80141 43.8258 10.1957 43.6277 9.87814C43.4295 9.56058 43.9249 9.37759 44.0428 9.56176Z"
        fill={fill}
      />
      <path
        d="M43.183 12.7411C43.4909 12.6408 43.6819 13.0882 43.3576 13.1803C43.0026 13.2818 43.0038 12.799 43.183 12.7411Z"
        fill={fill}
      />
      <path
        d="M45.47 10.7131C45.3567 10.8937 44.9321 10.7096 45.0536 10.464C45.2105 10.1453 45.6492 10.4286 45.47 10.7131Z"
        fill={fill}
      />
    </svg>
  );
}
